const { filter } = require("lodash");

window.filters = {
    options: {},

    init : function (agr) {
        this.options = agr.filters;
        
        this.bindEvents();
    },

    countCheckedOptions: function(type, group) {
        if(group) {
            // attribute count logic
            const checkedCount = $('input.attribute-group-'+group+'[type="checkbox"]:checked');
            var groupTitle = $('#attribute-group-'+group).data('title');

            if(checkedCount.length > 0) {
                $('#attribute-group-'+group+' span').text(groupTitle +' ('+checkedCount.length+')')
            } else {
                $('#attribute-group-'+group+' span').text(groupTitle)
            }
            return;
        }

        const checkedCount = $('input.'+type+'-checkbox[type="checkbox"]:checked');

        if(checkedCount.length > 0) {
            $('#'+type+'-btn span.'+type+'-count').removeClass('d-none').text('('+checkedCount.length+')');
            return;
        } 

        $('#'+type+'-btn span.'+type+'-count').addClass('d-none').text('(0)')
    },

    checkboxCheck: function(type) {
        loadedFields = [];
        if(filters.options.filter[type]) {
            loadedFields  = filters.options.filter[type].toString().split(",");
        }

        var checkedFields = $('input[type="checkbox"]:checked.'+type+'-checkbox');

        checkedFields.map(function(){
            return $(this).val()
        }).get().forEach(function (value) {
            idx = $.inArray(value, loadedFields);
            if (idx < 0) {
                loadedFields.push(value);
            }
        });

        $("input[name='filter["+type+"]']").val(loadedFields.toString());
        filters.updateOptions(type, loadedFields.toString())

        // Update count
        groups = checkedFields.map(function() {
            return $(this).data('group')
        }).get().filter((value, index, self) => self.indexOf(value) === index);

        if(groups.length > 0) {
            groups.forEach(group => filters.countCheckedOptions(type, group))
        } else {
            filters.countCheckedOptions(type);
        }
     },

    updateOptions: function(type, value) {
        filters.options.filter[type] = value;

        //clear checkbox for "all-values" checkbox
        checkbox = $("input.all-"+type+"-checkbox");
        if(checkbox) {
            checkbox.prop('checked', '')
        }
    },

    clearOptions: function (type) {
        filters.options.filter[type] = null;
        $("input[name='filter["+type+"]']").val(null);
        $("input."+type+"-checkbox").prop('checked', '');
    },

    bindEvents: function() {

        // Update count
        $('#filter-form').on('change', 'input.filter-checkbox[type="checkbox"]', function (e) {
            e.preventDefault();
            filters.countCheckedOptions($(this).data('type'), $(this).data('group'));
            return false;
        });

        $('input.filter-checkbox[type="checkbox"]').click(function() {
            type = $(this).data('type');
            value = $(this).val();

            if(value == 'clear') {
                filters.clearOptions(type);
                return;
            }

            checkedFields = [];
            if(filters.options.filter[type]) {
                checkedFields  = filters.options.filter[type].toString().split(",");
            }

            idx = $.inArray(value, checkedFields);
            if (idx >= 0) {
                checkedFields.splice(idx, 1);
            } else {
                checkedFields.push(value);
            }
            $("input[name='filter["+type+"]']").val(checkedFields.toString());
            filters.updateOptions(type, checkedFields.toString())
        });
    },

}